module.exports = {
  codFeePercent: 0.0333,
  dropzoneOptions: {
    thumbnailWidth: 150,
    maxFilesize: 20,
    maxFiles: 20,
    timeout: 100000,
  },
  getRate(rate, count) {
    if (rate == '-') {
      return '-'
    } else {
      let rateString = ''
      if (rate >= 9) {
        rateString = 'A'
      } else if (rate >= 8) {
        rateString = 'A-'
      } else if (rate >= 7) {
        rateString = 'B'
      } else if (rate >= 6) {
        rateString = 'B-'
      } else if (rate >= 5) {
        rateString = 'C'
      } else if (rate >= 4) {
        rateString = 'C-'
      } else if (rate >= 3) {
        rateString = 'D'
      } else if (rate >= 2) {
        rateString = 'D-'
      } else if (rate >= 1) {
        rateString = 'E'
      } else {
        rateString = 'E-'
      }
      if (count < 4) {
        rateString = '≈' + rateString
      }
      return rateString
    }
  },
  getGlobalScore(courierData) {
    let couriersCount = 0;
    const result = {
      rate: 0,
      total: 0
    }
    const couriers = ['JNE', 'SiCepat', 'Sap', 'iDexpress', 'lion'];
    couriers.forEach(courier => {
      if (courierData[courier] && (courierData[courier].undelivered != 0 ||
        courierData[courier].delivered != 0 ||
        courierData[courier].rts != 0)) {
        result.total += courierData[courier].total
        result.rate += courierData[courier].rate
        couriersCount++;
      }
    })
    if (couriersCount == 0) {
      result.score = '-';
    }
    else {
      result.rate = result.rate / couriersCount;
      result.score = module.exports.getRate(result.rate, result.total);
    }

    return result
  },
  getScoreColor(rating, width = null) {
    const approximate = rating.includes('≈');
    let style = 'border-radius: 50%; justify-content: center; align-items: center; display: flex; color: #203551;'
    if (width) {
      style += `width: ${width}px; height: ${width}px;`
    }
    else {
      style += `width: 30px; height: 30px;`
    }
    if (rating.includes('A')) {
      if (approximate) {
        return style + 'background: #c6f1f7; border-color: #A0E8F2; border-width: 2px; border-style: solid'
      }
      return style + 'background: #A0E8F2'
    } else if (rating.includes('B')) {
      if (approximate) {
        return style + 'background: #def6ec; border-color: #ACE9D0; border-width: 2px; border-style: solid'
      }
      return style + 'background: #ACE9D0'
    } else if (rating.includes('C')) {
      if (approximate) {
        return style + 'background: #ffefd8; border-color: #FFD79D; border-width: 2px; border-style: solid'
      }
      return style + 'background: #FFD79D'
    } else if (rating.includes('D')) {
      if (approximate) {
        return style + 'background: #fff8d6; border-color: #FFED98; border-width: 2px; border-style: solid'
      }
      return style + 'background: #FFED98'
    } else if (rating.includes('E')) {
      if (approximate) {
        return style + 'background: #ffebeb; border-color: #FFCECC; border-width: 2px; border-style: solid'
      }
      return style + 'background: #FFCECC'
    } else if (rating.includes('-')) {
      return style + 'background: #E5E5E5; border-color:  #E5E5E5;'
    } else {
      return style
    }
  },
  getRatingColor(rating) {
    const style = 'display: grid; place-content: center; width: 80px; height: 40px; background: #d1d5dd; border-radius: 40px; font-style: normal; font-weight: 600; font-size: 16px; line-height: 19px; text-align: center; letter-spacing: 0.02em; color: #203551;'
    const ratingInt = Number.parseInt(rating);
    if (ratingInt >= 8) {
      return style + 'background: #A0E8F2'
    } else if (ratingInt >= 6) {
      return style + 'background: #ACE9D0'
    } else if (ratingInt >= 4) {
      return style + 'background: #FFD79D'
    } else if (ratingInt >= 2) {
      return style + 'background: #FFED98'
    } else if (ratingInt >= 1) {
      return style + 'background: #FFCECC'
    } else if (ratingInt == 0) {
      return style + 'background: #E5E5E5'
    }
  },
  //for receiver score
  format_phone(phone) {
    let RECEIVER_PHONE = phone.replace(/[\W_]+/g, "");
    if (RECEIVER_PHONE && RECEIVER_PHONE.charAt(0) == '0') {
      RECEIVER_PHONE = RECEIVER_PHONE.substring(1, RECEIVER_PHONE.length);
    }

    if (RECEIVER_PHONE && RECEIVER_PHONE.charAt(0) != '+') {
      if (RECEIVER_PHONE.charAt(0) == '6' && RECEIVER_PHONE.charAt(1) == '2') {
        RECEIVER_PHONE = RECEIVER_PHONE.substring(2, RECEIVER_PHONE.length);
      }
    } else {
      RECEIVER_PHONE = RECEIVER_PHONE.substring(3, RECEIVER_PHONE.length);
    }
    return RECEIVER_PHONE;
  },
  convertPhone(RECEIVER_PHONE) {
    if (!RECEIVER_PHONE) {
      return ''
    }
    RECEIVER_PHONE = RECEIVER_PHONE.replace("'", "");
    if (RECEIVER_PHONE && RECEIVER_PHONE.charAt(0) == "0") {
      RECEIVER_PHONE =
        "62" + RECEIVER_PHONE.substring(1, RECEIVER_PHONE.length);
    }
    if (
      RECEIVER_PHONE &&
      RECEIVER_PHONE.charAt(0) !== "+" &&
      !(
        RECEIVER_PHONE.charAt(0) === "6" &&
        RECEIVER_PHONE.charAt(1) === "2"
      )
    ) {
      RECEIVER_PHONE = "62" + RECEIVER_PHONE;
    }
    return RECEIVER_PHONE.replace(/-| /, '').replace(/^\+/, '').replace(/^8/, '7')
  },
  getRateFromReceiver(data) {
    if (!data) {
      return '-'
    }
    let total = data.delivered + data.rts + data.undelivered
    let rate = data.rate
    if (!total) {
      return '-'
    } else {
      let rateString = ''
      if (rate >= 9) {
        rateString = 'A'
      } else if (rate >= 8) {
        rateString = 'A-'
      } else if (rate >= 7) {
        rateString = 'B'
      } else if (rate >= 6) {
        rateString = 'B-'
      } else if (rate >= 5) {
        rateString = 'C'
      } else if (rate >= 4) {
        rateString = 'C-'
      } else if (rate >= 3) {
        rateString = 'D'
      } else if (rate >= 2) {
        rateString = 'D-'
      } else if (rate >= 1) {
        rateString = 'E'
      } else {
        rateString = 'E-'
      }
      if (total < 4) {
        rateString = '≈' + rateString
      }
      return rateString
    }
  },
  /**
   * Generate WhatsApp URL with phone number and optional message
   * @param {string} phone - Phone number to send message to
   * @param {string} message - Optional message text to pre-fill
   * @param {string} type - URL type: 'api' (default) or 'wame'
   * @returns {string} Complete WhatsApp URL
   */
  getWhatsAppUrl(phone, message = '', type = 'api') {
    if (!phone) return '';

    // Convert phone to proper format using existing convertPhone function
    const formattedPhone = module.exports.convertPhone(phone);

    // Choose base URL based on type
    const baseUrl = type === 'wame' ? 'https://wa.me/' : 'https://api.whatsapp.com/send/?phone=';

    // Build URL with phone parameter
    let url = `${baseUrl}${formattedPhone}`;

    // Add message parameter if provided
    if (message) {
      const encodedMessage = encodeURIComponent(message);
      url += type === 'wame' ? '?' : '&';

      url += `text=${encodedMessage}`;
    }

    return url;
  }
}
